export default __webpack_public_path__ + "static/media/teo.5fc0a9ad.png";